<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>Report</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <!-- <div class="action-btn">
                                    <button pButton pRipple label="" icon="las la-plus" title="Add" 
                                        class="p-button-success p-mr-2"></button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                      
                        <!-- <p-tabView  [(activeIndex)]="selectedtab">
                            <p-tabPanel header="Customer Details"> -->
                        <table class="normal-table">
                            <tr>

                                <td style="width:17%" class="text-right">
                                    Temp Customer <span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <input type="text" [(ngModel)]="_CustomerSite" disabled pInputText>
                                        <button class="p-inputgroup-addon p-button" title="Add" type="button"
                                            (click)="showBasicDialog()">
                                            <i class="las la-search"></i>
                                        </button>
                                    </div>

                                </td>
                                <td>
                                    <button pButton label="Generate" (click)="GenerateReport()" class="p-button-success"></button>
                                  
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                               
                            </tr>
                        </table>
                        
                    </div>
                   
                    <p-dialog header="Report Popup" [(visible)]="displayBasic" [modal]="true"
                            [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                            <ng-template pTemplate="content">
                                <div class="popup-body">
                                    <div class="search-container">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label">
                                                <input type="text" id="inputtext" pInputText>
                                            </span>
                                            <button class="p-inputgroup-addon p-button" title="Search">
                                                <i class="pi pi-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <p-table [value]="_ReportPopupList" selectionMode="single"
                                            [(selection)]="selectedRequest" (onRowSelect)="onRowSelectPopup($event)"
                                             [paginator]="true" [rows]="10">
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <!-- <th *ngIf="_action != 'view'">
                                                </th> -->
                                                    <th pSortableColumn="requestno">Customer Name <p-sortIcon
                                                            field="requestno">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestedbranch">Customer Site Code
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestperson">Customer Type <p-sortIcon
                                                            field="requestperson">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestedbranch">Is Transporter
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestedbranch">Billing Cycle
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th>


                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-rowData let-_Expense>
                                                <tr [pSelectableRow]="rowData">
                                                    <!-- <td style="text-align: center" *ngIf="_action != 'view'">
                                                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                                                </td> -->
                                                    <td>{{_Expense.customername}}</td>
                                                    <td>{{_Expense.customersitecode}}</td>
                                                    <td>{{_Expense.companytype}}</td>
                                                    <td>{{_Expense.istransporter}}</td>
                                                    <td>{{_Expense.billingcycle}}</td>

                                                </tr>
                                            </ng-template>
                                        </p-table>
                                    </div>
                                </div>
                            </ng-template>
                        </p-dialog>
                   
                       
                </div>
            </div>
        </div>
    </div>
</div>

